const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

/**
 * @type {import('@sentry/nextjs').BrowserOptions}
 */
export const sentryCommonConfig = {
   dsn:
      SENTRY_DSN ||
      'https://5c385150b87b449ca424e8c9a85e74e6@o1112937.ingest.sentry.io/4504601371738112',

   tracesSampler(context) {
      // Ignore the health check endpoint
      if (context.transactionContext.name.indexOf('/api/health-check') > -1) {
         return 0;
      }

      // Default to 15% sample rate
      return 0.15;
   },
   // ...
   // Note: if you want to override the automatic release value, do not set a
   // `release` value here - use the environment variable `SENTRY_RELEASE`, so
   // that it will also get attached to your source maps
};
